import React from 'react';
import { getI18NMessage } from 'I18N/I18NHelper';
import { Radio, RadioGroup, FormControlLabel, TextField } from '@mui/material';
import AppHelper from 'js/app/AppHelper';
import { toggleMoreInstruction } from 'js/app/actions/AppActions';
import properties from 'properties';

class EmbedCodeView extends React.Component {
	constructor(props) {
		super(props);

        this.state = {
			embedType: 'html'
		};
	}

	render() {
		const isMoreInstructionEnabled = this.props.store ? this.props.store.getState().appData.appData.toggleMoreInstruction : false;

		return (
			<React.Fragment>
				<span className='ec_heading bold'>{ getI18NMessage('ec_heading') }</span>
				<RadioGroup name='embedtype' value={ this.state.embedType } className='embetype_grp' onChange={ this.handleEmbedTypeChange.bind(this) }>
					<FormControlLabel value='html' control={ <Radio /> } label={ getI18NMessage('embedHtml') } />
					<FormControlLabel value='javascript' control={<Radio />} label={ getI18NMessage('embedJS') } />
					<FormControlLabel value='mail' control={<Radio />} label={ getI18NMessage('embedMail') } />
        		</RadioGroup>
				{
					this.state.embedType === 'html' && this.embedHTML()
				}
				{
					this.state.embedType === 'javascript' && this.embedJavascript()
				}
				{
					this.state.embedType === 'mail' && this.embedMail()
				}
				{
					!this.props.fromCongratsView &&
					<div>
						<span className={`more_instruction underline bold float_left cur_pointer hyperlink ${ isMoreInstructionEnabled ? 'more_inst_enabled' : '' }`}
							 onClick={ this.showMoreInstructions.bind(this) }> { getI18NMessage('moreinstructionPart1') }</span>
						<span className={`more_instruction float_left ${ isMoreInstructionEnabled ? 'more_inst_enabled' : '' }`}> &nbsp;{ getI18NMessage('moreinstructionPart2') }</span>
					</div>
				}
			</React.Fragment>
		);
	}

	showMoreInstructions() {
		this.props.store.dispatch( toggleMoreInstruction() );
	}

	getEnterpriseUrl(scriptURL) {
		const enterpriseId = AppHelper.getParamData('icentid');
		const enterpriseEwrUrl = properties.enterpriseEwrUrl;
		const urlObj = enterpriseEwrUrl ? JSON.parse(enterpriseEwrUrl.replace(/'/g, '"')) : {};
		if(urlObj[enterpriseId]) {
			scriptURL = urlObj[enterpriseId];
		}
		return scriptURL;
	}

	getScriptUrl () {
		if ( this.props.issueConfig ) {
			const config = this.props.issueConfig.config;
			const rbgFontColor = config.triggerfontcolor;
			const rbgbgColor = config.triggerbgcolor;
			const fontcolor = AppHelper.rgbToHexColor(Number(rbgFontColor.r), Number(rbgFontColor.g), Number(rbgFontColor.b))
			const bgcolor = AppHelper.rgbToHexColor(Number(rbgbgColor.r), Number(rbgbgColor.g), Number(rbgbgColor.b))
			const isContextPathEnabled = properties.contextPath && properties.contextPath !== '' && properties.contextPath !== '#CONTEXTPATH#';
			
			let scriptURL = this.getEnterpriseUrl(window.location.origin);
			
			if ( isContextPathEnabled ) {
				scriptURL = scriptURL + "/" + properties.contextPath;
			}
			
			scriptURL = scriptURL + "/issuecollectorform/issuecollector.js?collectorid=" + config.id + 
				"&projectid=" + config.projectid + "&position=" + config.position +
				"&triggertext=" + config.triggertext + "&triggerbgcolor=" + bgcolor.substring(1) + "&triggerfontcolor=" +
				fontcolor.substring(1);

			if ( isContextPathEnabled ) {
				scriptURL += '&contextPath=' + properties.contextPath;
			}

			return scriptURL;
		} else {
			return;
		}
	}

	embedHTML() {
		const popupUrl = this.getScriptUrl();
		const scriptText = '<script type="text/javascript" src="'+popupUrl+'"></script>';
		return (
			<React.Fragment>
				<TextField label="Code" multiline fullWidth disabled rows={ this.props.fromCongratsView ? '6' : '7'} className={`embed_script float_left ${this.props.editmode ? 'editmode' : ''}`} variant="outlined" 
				value={scriptText} />
				<span className='embedhelp_text float_left full_width'>{ getI18NMessage('embedhelptext') }</span>
			</React.Fragment>
		);
	}

	embedJavascript() {
		const popupUrl = this.getScriptUrl();
		const scriptText = "// Requires jQuery\n"+
		"jQuery.ajax({\n"+
			"\turl: '"+popupUrl+"',\n"+
			"\ttype: 'get',\n"+
			"\tcache: true,\n"+
			"\tdataType: 'script'\n"+
		"});";
		return (
			<React.Fragment>
				<TextField label="Code" multiline fullWidth disabled rows={ this.props.fromCongratsView ? '6' : '7'} className={`embed_script float_left ${this.props.editmode ? 'editmode' : ''}`} variant="outlined" 
				value={scriptText} />
				<span className='embedhelp_text float_left full_width'>{ getI18NMessage('embedhelptextforjavacsript') }</span>
			</React.Fragment>
		);
	}

	embedMail () {
		const config = this.props.issueConfig.config;
		const w_url = this.getEnterpriseUrl(window.location.origin) + "/form?collectorid=" + config.id + "&projectid=" + config.projectid + "&source=mail";

		return (
			<React.Fragment>
				<TextField label="URL" multiline fullWidth disabled rows={ this.props.fromCongratsView ? '6' : '7'} 
					className={`embed_script float_left ${this.props.editmode ? 'editmode' : ''}`} variant="outlined" 
					value={w_url} />
				<span className='embedhelp_text float_left full_width'>{ getI18NMessage('embedhelptextForMail') }</span>
			</React.Fragment>
		);
	}
	
	 /* istanbul ignore next */
	handleEmbedTypeChange(event) {
		this.setState({
			embedType: event.target.value
		})
	}
}

export default EmbedCodeView;